import { render, staticRenderFns } from "./SendNotification.vue?vue&type=template&id=7a4ae372"
import script from "./SendNotification.vue?vue&type=script&lang=js"
export * from "./SendNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports